
import { createContext } from 'react';

export const AppPermissionsContext = createContext();
	